/**
 * This file was generated by st-open-api
 */
import {ErrorHandler} from '../interface/i-$-open-api';
import {IDeleteIndividualOrderPathParameter} from '../interface/parameter/i-delete-individual-order-path-parameter';
import {IDeleteSubOrderPathParameter} from '../interface/parameter/i-delete-sub-order-path-parameter';
import {IGetAllOrdersQueryParameter} from '../interface/parameter/i-get-all-orders-query-parameter';
import {IGetCollectiveOrderPathParameter} from '../interface/parameter/i-get-collective-order-path-parameter';
import {IGetCollectiveOrderQueryParameter} from '../interface/parameter/i-get-collective-order-query-parameter';
import {IGetIndividualOrderPathParameter} from '../interface/parameter/i-get-individual-order-path-parameter';
import {IGetSubOrderPathParameter} from '../interface/parameter/i-get-sub-order-path-parameter';
import {IImpactContributionCalculationPathParameter} from '../interface/parameter/i-impact-contribution-calculation-path-parameter';
import {IImpactContributionCalculationResponse} from '../interface/components/i-impact-contribution-calculation-response';
import {IListProjectsPathParameter} from '../interface/parameter/i-list-projects-path-parameter';
import {IOrderCheckOrderRequest} from '../interface/components/i-order-check-order-request';
import {IOrderCheckOrderResponse} from '../interface/components/i-order-check-order-response';
import {IOrderCollectiveGetInfoResponse} from '../interface/components/i-order-collective-get-info-response';
import {IOrderCollectiveResponse} from '../interface/components/i-order-collective-response';
import {IOrderDeleteInfoResponse} from '../interface/components/i-order-delete-info-response';
import {IOrderGetAllInfoResponse} from '../interface/components/i-order-get-all-info-response';
import {IOrderGetInfoResponse} from '../interface/components/i-order-get-info-response';
import {IOrderIndividualBatchRequest} from '../interface/components/i-order-individual-batch-request';
import {IOrderIndividualBatchResponse} from '../interface/components/i-order-individual-batch-response';
import {IOrderInfoRequestHeaderCreate} from '../interface/components/i-order-info-request-header-create';
import {IOrderInfoRequestHeader} from '../interface/components/i-order-info-request-header';
import {IOrderListProjectsResponse} from '../interface/components/i-order-list-projects-response';
import {IOrderRequest} from '../interface/components/i-order-request';
import {IOrderResponse} from '../interface/components/i-order-response';
import {IOrderSubOrderDeleteResponse} from '../interface/components/i-order-sub-order-delete-response';
import {IOrderSubOrderGetInfoResponse} from '../interface/components/i-order-sub-order-get-info-response';
import {IOrderSubOrderRequest} from '../interface/components/i-order-sub-order-request';
import {IOrderSubOrderResponse} from '../interface/components/i-order-sub-order-response';
import {IOrderUpdateIndividualOrderRequest} from '../interface/components/i-order-update-individual-order-request';
import {IOrderUpdateInfoSubOrderRequest} from '../interface/components/i-order-update-info-sub-order-request';
import {IUpdateCollectiveOrderPathParameter} from '../interface/parameter/i-update-collective-order-path-parameter';
import {IUpdateIndividualOrderPathParameter} from '../interface/parameter/i-update-individual-order-path-parameter';
import {IUpdateSubOrderPathParameter} from '../interface/parameter/i-update-sub-order-path-parameter';
import {RequestInterceptor} from '../interface/i-$-open-api';
import {ResponseInterceptor} from '../interface/i-$-open-api';
import {http} from '../function/http';
import {openApi} from '../function/open-api';

export class OrderBaseService {

    checkOrder = async (body: IOrderCheckOrderRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderCheckOrderResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/order/v1/checkOrder`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    createBatchIndividualOrder = async (body: IOrderIndividualBatchRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderIndividualBatchResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/order/v1/individualOrdersBatched`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    createCollectiveOrder = async (body: IOrderInfoRequestHeaderCreate, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderCollectiveResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/order/v1/collectiveOrder`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    createIndividualOrder = async (body: IOrderRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/order/v1/individualOrder`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    createSubOrder = async (body: IOrderSubOrderRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderSubOrderResponse> => {
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/order/v1/subOrder`,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    deleteIndividualOrder = async (pathParameter: IDeleteIndividualOrderPathParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderDeleteInfoResponse> => {
    
        const pathParam = {
            'orderId': pathParameter.orderId,
        };
    
        const response = await http({
                method: 'DELETE',
                url: `${openApi.endpointUrl}/order/v1/individualOrder/{orderId}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    deleteSubOrder = async (pathParameter: IDeleteSubOrderPathParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderSubOrderDeleteResponse> => {
    
        const pathParam = {
            'orderId': pathParameter.orderId,
        };
    
        const response = await http({
                method: 'DELETE',
                url: `${openApi.endpointUrl}/order/v1/subOrder/{orderId}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    getAllOrders = async (queryParameter: IGetAllOrdersQueryParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderGetAllInfoResponse> => {
    
        const queryParam = [
            {name: 'cursor', value: queryParameter.cursor},
            {name: 'limit', value: queryParameter.limit},
        ];
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/order/v1/allOrder`,
                queryParameter: queryParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    getCollectiveOrder = async (pathParameter: IGetCollectiveOrderPathParameter, queryParameter: IGetCollectiveOrderQueryParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderCollectiveGetInfoResponse> => {
    
        const queryParam = [
            {name: 'cursor', value: queryParameter.cursor},
            {name: 'limit', value: queryParameter.limit},
        ];
    
        const pathParam = {
            'collectiveOrderId': pathParameter.collectiveOrderId,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/order/v1/collectiveOrder/{collectiveOrderId}`,
                queryParameter: queryParam,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    getIndividualOrder = async (pathParameter: IGetIndividualOrderPathParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderGetInfoResponse> => {
    
        const pathParam = {
            'orderId': pathParameter.orderId,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/order/v1/individualOrder/{orderId}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    getSubOrder = async (pathParameter: IGetSubOrderPathParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderSubOrderGetInfoResponse> => {
    
        const pathParam = {
            'orderId': pathParameter.orderId,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/order/v1/subOrder/{orderId}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    impactContributionCalculation = async (pathParameter: IImpactContributionCalculationPathParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IImpactContributionCalculationResponse> => {
    
        const pathParam = {
            'projectId': pathParameter.projectId,
            'netValue': pathParameter.netValue,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/order/v1/projects/impact-contribution/{projectId}/{netValue}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    listProjects = async (pathParameter: IListProjectsPathParameter, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderListProjectsResponse> => {
    
        const pathParam = {
            'language': pathParameter.language,
        };
    
        const response = await http({
                method: 'GET',
                url: `${openApi.endpointUrl}/order/v1/projects/{language}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                },
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    updateCollectiveOrder = async (pathParameter: IUpdateCollectiveOrderPathParameter, body: IOrderInfoRequestHeader, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderCollectiveResponse> => {
    
        const pathParam = {
            'collectiveOrderId': pathParameter.collectiveOrderId,
        };
    
        const response = await http({
                method: 'PATCH',
                url: `${openApi.endpointUrl}/order/v1/collectiveOrder/{collectiveOrderId}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    updateIndividualOrder = async (pathParameter: IUpdateIndividualOrderPathParameter, body: IOrderUpdateIndividualOrderRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderResponse> => {
    
        const pathParam = {
            'orderId': pathParameter.orderId,
        };
    
        const response = await http({
                method: 'PATCH',
                url: `${openApi.endpointUrl}/order/v1/individualOrder/{orderId}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

    updateSubOrder = async (pathParameter: IUpdateSubOrderPathParameter, body: IOrderUpdateInfoSubOrderRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<IOrderSubOrderResponse> => {
    
        const pathParam = {
            'orderId': pathParameter.orderId,
        };
    
        const response = await http({
                method: 'PATCH',
                url: `${openApi.endpointUrl}/order/v1/subOrder/{orderId}`,
                urlParameter: pathParam,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

}
